export type StoredBusinessAssociation = {
  id: number
  name: string
  role: string
}

const SELECTED_BUSINESS_ASSOCIATION_SESSION_STORAGE_KEY =
  'selectedBusinessAssociationByUser'

type SelectedBusinessAssociationsByUser = Record<
  string,
  StoredBusinessAssociation
>

const getStoredSelectedBusinessAssociationsByUser =
  (): SelectedBusinessAssociationsByUser => {
    if (typeof window === 'undefined') {
      return {}
    }

    const rawValue = window.sessionStorage.getItem(
      SELECTED_BUSINESS_ASSOCIATION_SESSION_STORAGE_KEY
    )

    if (!rawValue) {
      return {}
    }

    try {
      return JSON.parse(rawValue) as SelectedBusinessAssociationsByUser
    } catch {
      window.sessionStorage.removeItem(
        SELECTED_BUSINESS_ASSOCIATION_SESSION_STORAGE_KEY
      )
      return {}
    }
  }

export const getStoredSelectedBusinessAssociationForUser = (
  userName: string | undefined
): StoredBusinessAssociation | null => {
  if (!userName) {
    return null
  }

  return getStoredSelectedBusinessAssociationsByUser()[userName] ?? null
}

export const setStoredSelectedBusinessAssociationForUser = ({
  userName,
  association,
}: {
  userName: string | undefined
  association: StoredBusinessAssociation | null
}) => {
  if (!userName || typeof window === 'undefined') {
    return
  }

  const selectedBusinessAssociationsByUser =
    getStoredSelectedBusinessAssociationsByUser()

  if (association) {
    selectedBusinessAssociationsByUser[userName] = association
  } else {
    delete selectedBusinessAssociationsByUser[userName]
  }

  if (Object.keys(selectedBusinessAssociationsByUser).length === 0) {
    window.sessionStorage.removeItem(
      SELECTED_BUSINESS_ASSOCIATION_SESSION_STORAGE_KEY
    )
    return
  }

  window.sessionStorage.setItem(
    SELECTED_BUSINESS_ASSOCIATION_SESSION_STORAGE_KEY,
    JSON.stringify(selectedBusinessAssociationsByUser)
  )
}
